
(function() {
  'use strict';
  
  function initSwiperGallery() {
    const galleryContainer = document.querySelector('.product-swiper');
    const thumbnailsContainer = document.querySelector('.product-thumbnails-swiper');
    
    if (!galleryContainer) {
      return;
    }

    if (typeof Swiper === 'undefined') {
      setTimeout(initSwiperGallery, 100);
      return;
    }

    let thumbnailsSwiper = null;
    if (thumbnailsContainer && thumbnailsContainer.querySelectorAll('.swiper-slide').length > 0) {
      thumbnailsSwiper = new Swiper('.product-thumbnails-swiper', {
        spaceBetween: 10,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            spaceBetween: 10,
          },
        },
      });
    }

    const mainSwiper = new Swiper('.product-swiper', {
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      slidesPerView: 1,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: thumbnailsSwiper ? {
        swiper: thumbnailsSwiper,
      } : undefined,
      on: {
        slideChange: function() {

          const activeIndex = this.activeIndex;
          const thumbnails = document.querySelectorAll('.product-thumbnails-swiper .swiper-slide');
          thumbnails.forEach((thumb, index) => {
            if (index === activeIndex) {
              thumb.classList.add('active', 'swiper-slide-thumb-active');
            } else {
              thumb.classList.remove('active', 'swiper-slide-thumb-active');
            }
          });
        },
        init: function() {

          this.emit('slideChange');
        },
      },
    });

    if (thumbnailsContainer) {
      const thumbnailSlides = thumbnailsContainer.querySelectorAll('.swiper-slide');
      thumbnailSlides.forEach((thumb, index) => {
        thumb.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          console.log(`🖱️ Thumbnail ${index} clicked - navigating to slide ${index}`);
          mainSwiper.slideTo(index);
        });
      });
      console.log(`✅ Added click handlers to ${thumbnailSlides.length} thumbnails`);
    }

    window.productSwiper = mainSwiper;
    window.addEventListener('load', function () { mainSwiper.update(); });
    window.addEventListener('resize', function () { mainSwiper.update(); });
    setTimeout(function () { mainSwiper.update(); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwiperGallery);
  } else {
    initSwiperGallery();
  }
})();

